module.exports = __webpack_public_path__ + "static/media/guide_btn.4568e90f.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/guide_btn.png
// module id = 489
// module chunks = 0